import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AddInteractionService} from '../../services/interaction/add-interaction.service';
import {InteractionData} from '../../types/interaction/interaction-data';
import {FormHelperService} from '../../services/person/form-helper-service';
import {User} from '../../types/security/user';
import {SecurityService} from '../../services/security/security.service';
import {Subscription} from 'rxjs';
import {ENTRY_STATES} from '../../types/entry/EntryStatesEnum';
import * as _ from 'lodash';

@Component({
  selector: 'wsd-add-organization-interaction',
  templateUrl: './add-organization-interaction.component.html',
  styleUrls: ['./add-organization-interaction.component.css']
})
export class AddOrganizationInteractionComponent implements OnInit, OnDestroy {

  @Output()
  onSave = new EventEmitter<InteractionData>();

  @Output()
  onDelete = new EventEmitter<InteractionData>();

  display: boolean;

  ENTRY_STATES = ENTRY_STATES;

  interaction: InteractionData;

  interactionForm: UntypedFormGroup;

  user: User;

  private securitySubscription: Subscription;

  constructor(private addInteractionService: AddInteractionService,
              private fb: UntypedFormBuilder,
              private formHelper: FormHelperService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.interactionForm = this.fb.group({
      subject: ['', [Validators.required, Validators.maxLength(255)]],
      date: ['', Validators.required],
      person: ['', [Validators.required, Validators.maxLength(255)]],
      important: [false],
      confidential: [false],
      summary: ['', [Validators.required, Validators.maxLength(4096)]]
    });
    this.securitySubscription = this.securityService.getLoggedUser().subscribe((user: User) => {
      this.user = user;
    });
    this.addInteractionService.messageSent$.subscribe(
      (interaction: InteractionData) => {
        this.initForm(interaction);
        this.interactionForm.markAsPristine();
        this.display = true;
      }
    );
  }

  private initForm(data: InteractionData) {
    this.interaction = data;
    if (!this.interaction.person) {
      this.interaction.person = this.user.firstName.concat(' ').concat(this.user.lastName);
    }
    this.interactionForm.reset();
    this.interactionForm.patchValue(this.interaction);
  }

  save() {
    this.formHelper.validateAllFormFields(this.interactionForm);
    if (this.interactionForm.invalid) {
      return;
    }
    _.assign(this.interaction, this.interactionForm.value);
    this.interaction.enteredBy = this.user;
    this.display = false;
    this.onSave.emit(this.interaction);
    this.display = false;
  }

  delete() {
    this.display = false;
    this.onDelete.emit(this.interaction);
  }

  ngOnDestroy() {
    this.securitySubscription.unsubscribe();
  }
}
